module.exports = __webpack_public_path__ + "img/logo-company.330c5520.png";